export const link = (href: string) => ({ kind: "link", href }) as const;

export const action = (run: () => void) => ({ kind: "action", run }) as const;
